import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ItemSucursal from './ItemSucursal';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;


function ReporteDiarioPollo() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [sucursales, setSucursales] = useState([]);
    const [regional, setRegional] = useState('990');
    const [idProducto, setIdProducto] = useState('POLLO');
    const [actualizar, setActualizar] = useState(true);
    const [proyeccion, setProyeccion] = useState([]);
    const [viewN, setViewN] = useState(false);
    const [viewT, setViewT] = useState(0);
    function getInformacionProyeccion() {
        
        fetch(`${server}/reporte/getProyeccionSucursal`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setViewN(true);
                    setProyeccion(data.ok);
                    console.log("Proyecciones")
                    console.log(data.ok)
                } else {
                    MsgUtils.msgError(data.error)
                }
                setLoading(false);
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function refrescarTotales() {
        setViewT(curr => curr + 1);
    }
    function sumarValores(columna) {
        var table = document.getElementById('tablaDatos')
        var tr = table.getElementsByTagName("tr");
        var suma = 0
        var i;
        for (i = 0; i < tr.length; i++) {
            var td = tr[i].getElementsByTagName("td")[columna];
            if (td) {
                var txtValue = td.textContent || td.innerText;
                var valor = parseFloat(txtValue);
                if(!isNaN(valor)){
                    suma = suma + valor;
                }
            }
        }
        return suma
    }
    useEffect(() => {
        console.log("Comienzo")
        setLoading(true);
        setViewN(false);
        setViewT(0);
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    console.log("sucursales")
                    console.log(data.ok)
                    getInformacionProyeccion();
                    setSucursales(data.ok);
                }

            })
            .catch(error => MsgUtils.msgError(error));
    }, [regional])
    return (
        <>
            <div className='container-fluid bg-gradient bg-dark py-1'>
                <div className="input-group input-group-sm my-auto" style={{ width: '300px' }}>
                    <span className="input-group-text bg-secondary bg-gradient text-light" >Regional</span>
                    <select className=" form-select text-center "
                        value={regional} onChange={(e) => setRegional(e.target.value)}
                    >
                        <option value='990'>CBBA</option>
                        <option value='991'>SCRZ</option>
                    </select>
                    <button className='btn btn-success mx-2' onClick={() => setActualizar(!actualizar)}>
                        <i className="fa-solid fa-arrows-rotate"></i>Actualizar
                    </button>
                </div>
            </div>
            <div className='container-fluid py-2'>
                <div className='row row-cols-2 g-1'>
                    <div className='col col-6'>
                        <button className={`btn w-100 ${idProducto == 'POLLO' ? 'btnActivo text-light' : 'btn-light'}`} 
                            onClick={() => setIdProducto('POLLO')}>POLLO en Bandejas</button>
                    </div>
                    <div className='col col-6'>
                        <button className={`btn w-100 ${idProducto == 'PIPOC' ? 'btnActivo text-light' : 'btn-light'}`} 
                            onClick={() => setIdProducto('PIPOC')}>PIPOCAS en Porciones</button>
                    </div>
                </div>
                <div className='table table-responsive'>
                    <table className="table table-striped" id='tablaDatos'>
                        <thead className='bg-danger text-light'>
                            <tr>
                                <th>SUCURSAL</th>
                                <th>PROGRAMADO</th>
                                <th>INV INICIAL</th>
                                {idProducto=='POLLO'&&<th>INV CRUDO</th>}
                                <th>INV MARINADO</th>
                                {idProducto=='PIPOC'&&<th>INV CRUDO</th>}
                                <th>INGRESOS</th>
                                <th>TRÁNSITO</th>
                                <th>SALIDAS</th>
                                <th>RESERVAS</th>
                                <th>VENTAS Y REFRIGERIOS</th>
                                <th>SALDO</th>
                            </tr>
                        </thead>
                        {viewN && <tbody onChange={()=>console.log("datos finalizados")}>
                            {sucursales.map((item, index) => {
                                return (
                                    <ItemSucursal proyeccion={proyeccion}
                                        idProducto={idProducto}
                                        sucursal={item} actualizar={actualizar} key={index}
                                        callback={refrescarTotales} />
                                )
                            })}
                        </tbody>}
                        {viewN && (viewT > 0) &&
                        <tfoot className='fondoMostasa text-center'>
                            <tr>
                                <th></th>
                                <th>{parseInt(sumarValores(0))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(1).toFixed(2):parseInt(sumarValores(1))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(2).toFixed(2):parseInt(sumarValores(2))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(3).toFixed(2):parseInt(sumarValores(3))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(4).toFixed(2):parseInt(sumarValores(4))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(5).toFixed(2):parseInt(sumarValores(5))}</th>

                                <th>{idProducto=='POLLO'?sumarValores(6).toFixed(2):parseInt(sumarValores(6))}</th>

                                <th>{idProducto=='POLLO'?sumarValores(7).toFixed(2):parseInt(sumarValores(7))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(8).toFixed(2):parseInt(sumarValores(8))}</th>
                                <th>{idProducto=='POLLO'?sumarValores(9).toFixed(2):parseInt(sumarValores(9))}</th>
                            </tr>
                        </tfoot> }
                    </table>
                </div>
            </div>
        </>
    )
}

export default ReporteDiarioPollo